import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createSubscriptionOption as universalCreateSubscriptionOption, updateSubscriptionOption as universalUpdateSubscriptionOption, deleteSubscriptionOption as universalDeleteSubscriptionOption, bulkCreateSubscriptionOptions as universalBulkCreateSubscriptionOptions, bulkUpdateSubscriptionOptions as universalBulkUpdateSubscriptionOptions, bulkDeleteSubscriptionOptions as universalBulkDeleteSubscriptionOptions, assignSubscriptionOptionsToProduct as universalAssignSubscriptionOptionsToProduct, allowOneTimePurchases as universalAllowOneTimePurchases, getSubscriptionOption as universalGetSubscriptionOption, getSubscriptionOptionsForProduct as universalGetSubscriptionOptionsForProduct, listSubscriptionOptions as universalListSubscriptionOptions, calculatePrices as universalCalculatePrices, bulkCalculatePrices as universalBulkCalculatePrices, bulkCalculatePricesForProducts as universalBulkCalculatePricesForProducts, getProductIdsForSubscriptionOption as universalGetProductIdsForSubscriptionOption, getOneTimePurchasesStatus as universalGetOneTimePurchasesStatus, } from './stores-v1-subscription-option.universal';
import { SubscriptionFrequency, DiscountType, } from './stores-v1-subscription-option.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.stores.v1.subscription_option', module_name: 'wix-stores.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createSubscriptionOption: (subscriptionOption) => {
            const methodLogData = {
                method_name: 'createSubscriptionOption',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.createSubscriptionOption',
            };
            return universalCreateSubscriptionOption(subscriptionOption, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateSubscriptionOption: (_id, subscriptionOption) => {
            const methodLogData = {
                method_name: 'updateSubscriptionOption',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.updateSubscriptionOption',
            };
            return universalUpdateSubscriptionOption(_id, subscriptionOption, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteSubscriptionOption: (_id) => {
            const methodLogData = {
                method_name: 'deleteSubscriptionOption',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.deleteSubscriptionOption',
            };
            return universalDeleteSubscriptionOption(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateSubscriptionOptions: (subscriptionOptions) => {
            const methodLogData = {
                method_name: 'bulkCreateSubscriptionOptions',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.bulkCreateSubscriptionOptions',
            };
            return universalBulkCreateSubscriptionOptions(subscriptionOptions, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateSubscriptionOptions: (subscriptionOptions) => {
            const methodLogData = {
                method_name: 'bulkUpdateSubscriptionOptions',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.bulkUpdateSubscriptionOptions',
            };
            return universalBulkUpdateSubscriptionOptions(subscriptionOptions, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteSubscriptionOptions: (ids) => {
            const methodLogData = {
                method_name: 'bulkDeleteSubscriptionOptions',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.bulkDeleteSubscriptionOptions',
            };
            return universalBulkDeleteSubscriptionOptions(ids, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        assignSubscriptionOptionsToProduct: (productId, options) => {
            const methodLogData = {
                method_name: 'assignSubscriptionOptionsToProduct',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.assignSubscriptionOptionsToProduct',
            };
            return universalAssignSubscriptionOptionsToProduct(productId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        allowOneTimePurchases: (productId, allowed) => {
            const methodLogData = {
                method_name: 'allowOneTimePurchases',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.allowOneTimePurchases',
            };
            return universalAllowOneTimePurchases(productId, allowed, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getSubscriptionOption: (_id) => {
            const methodLogData = {
                method_name: 'getSubscriptionOption',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.getSubscriptionOption',
            };
            return universalGetSubscriptionOption(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getSubscriptionOptionsForProduct: (productId, options) => {
            const methodLogData = {
                method_name: 'getSubscriptionOptionsForProduct',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.getSubscriptionOptionsForProduct',
            };
            return universalGetSubscriptionOptionsForProduct(productId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listSubscriptionOptions: (ids) => {
            const methodLogData = {
                method_name: 'listSubscriptionOptions',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.listSubscriptionOptions',
            };
            return universalListSubscriptionOptions(ids, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        calculatePrices: (options) => {
            const methodLogData = {
                method_name: 'calculatePrices',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.calculatePrices',
            };
            return universalCalculatePrices(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCalculatePrices: (prices, options) => {
            const methodLogData = {
                method_name: 'bulkCalculatePrices',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.bulkCalculatePrices',
            };
            return universalBulkCalculatePrices(prices, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCalculatePricesForProducts: (items) => {
            const methodLogData = {
                method_name: 'bulkCalculatePricesForProducts',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.bulkCalculatePricesForProducts',
            };
            return universalBulkCalculatePricesForProducts(items, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getProductIdsForSubscriptionOption: (_id, options) => {
            const methodLogData = {
                method_name: 'getProductIdsForSubscriptionOption',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.getProductIdsForSubscriptionOption',
            };
            return universalGetProductIdsForSubscriptionOption(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getOneTimePurchasesStatus: (productId) => {
            const methodLogData = {
                method_name: 'getOneTimePurchasesStatus',
                service_name: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.v1.subscription_option,environment=velo-frontend,method-fqn=wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.getOneTimePurchasesStatus',
            };
            return universalGetOneTimePurchasesStatus(productId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        SubscriptionFrequency,
        DiscountType,
    };
}
//# sourceMappingURL=stores-v1-subscription-option.frontend.js.map